import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'et',
  months: [
    'jaanuar',
    'veebruar',
    'märts',
    'aprill',
    'mai',
    'juuni',
    'juuli',
    'august',
    'september',
    'oktoober',
    'november',
    'detsember',
  ],
  monthsShort: ['jaan', 'veebr', 'märts', 'apr', 'mai', 'juuni', 'juuli', 'aug', 'sept', 'okt', 'nov', 'dets'],
  weekdays: ['pühapäev', 'esmaspäev', 'teisipäev', 'kolmapäev', 'neljapäev', 'reede', 'laupäev'],
  weekdaysMin: ['P', 'E', 'T', 'K', 'N', 'R', 'L'],
  weekdaysShort: ['pühap', 'esmasp', 'teisip', 'kolmap', 'neljap', 'reede', 'laup'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'DD.MM.YYYY',
    LL: 'DD. MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'DD. MMMM',
    LLL: 'DD. MMMM YYYY HH:mm',
    'LLL-Y': 'DD. MMMM HH:mm',
    LLLL: 'dddd DD. MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd DD. MMMM HH:mm',
    l: 'DD.MM.YYYY',
    'l-Y': 'DD.MM',
    ll: 'DD. MMM YYYY',
    'll-Y': 'DD. MMM',
    lll: 'DD. MMM YYYY HH:mm',
    'lll-Y': 'DD. MMM HH:mm',
    llll: 'ddd DD. MMM YYYY HH:mm',
    'llll-Y': 'ddd DD. MMM HH:mm',
    'll-Y+w': 'ddd, D. MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D. MMMM YYYY HH:mm ([GMT]Z)',
  },
  past: {
    y: { one: '%s a eest', other: '%s a eest' },
    M: { one: '%s kuu eest', other: '%s kuu eest' },
    w: { one: '%s näd eest', other: '%s näd eest' },
    d: { one: '%s p eest', other: '%s p eest' },
    h: { one: '%s t eest', other: '%s t eest' },
    m: { one: '%s min eest', other: '%s min eest' },
    s: { one: '%s sek eest', other: '%s sek eest' },
  },
  future: {
    y: { one: '%s a pärast', other: '%s a pärast' },
    M: { one: '%s kuu pärast', other: '%s kuu pärast' },
    w: { one: '%s näd pärast', other: '%s näd pärast' },
    d: { one: '%s p pärast', other: '%s p pärast' },
    h: { one: '%s t pärast', other: '%s t pärast' },
    m: { one: '%s min pärast', other: '%s min pärast' },
    s: { one: '%s sek pärast', other: '%s sek pärast' },
  },
  abbr: {
    y: { one: '%s aasta', other: '%s aastat' },
    M: { one: '%s kuu', other: '%s kuud' },
    w: { one: '%s nädal', other: '%s nädalat' },
    d: { one: '%s päev', other: '%s päeva' },
    h: { one: '%s tund', other: '%s tundi' },
    m: { one: '%s minut', other: '%s minutit' },
    s: { one: '%s sekund', other: '%s sekundit' },
  },
  justNow: 'praegu',
  yesterday: 'eile',
  today: 'täna',
  tomorrow: 'homme',
  weekStart: 1,
};
const localeName: LocaleName = 'et';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (): string => '',
};
